import { ADMIN_CREATE_ORGANISATION_UPDATE } from './organisationsMapProps'

export interface IOrganisationsState {
  createOrganisationStatus: { success: boolean; message: string }
}

const initialState: IOrganisationsState = {
  createOrganisationStatus: {
    success: false,
    message: '',
  },
}
export function organisationsReducer(
  state: IOrganisationsState = initialState,
  action: any,
): IOrganisationsState {
  switch (action.type) {
    case ADMIN_CREATE_ORGANISATION_UPDATE:
      return { ...state, createOrganisationStatus: action.payload }
    default:
      return state
  }
}
